import { lazy } from "./util";

// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

export const ACTIVITY_STATUS = {
  all: "all",
  approved: "approved",
  pending: "pending",
  rejected: "rejected",
};

export const URLS = {
  index: () => "/",
  login: () => "/login",
  loginpw: () => "/loginpw",

  privacyPolicy: () => "/privacy-policy",
  termsOfService: () => "/terms-of-service",

  cHome: () => "/c",
  cLoginpw: () => "/c/loginpw",
  cActivities: (status: string) => `/c/activities/${status}`,
  cActivitiesAll: () => `/c/activities/${ACTIVITY_STATUS.all}`,
  cActivitiesDetail: (uid: string) => `/c/activities/detail/${uid}`,
  cCategories: () => "/c/categories",
  cCategoriesDetail: (uid: string) => `/c/categories/detail/${uid}`,
  cVolunteers: () => "/c/volunteers",
  cVolunteersDetail: (uid: string) => `/c/volunteers/detail/${uid}`,
  cVolunteerActivities: (vuid: string, status: string) =>
    `/c/volunteers/detail/${vuid}/activities/${status}`,
  // TODO organizations

  vHome: () => "/v",
  vProfile: () => "/v/profile",
  vActivities: (status: string) => `/v/activities/${status}`,
  vActivitiesAll: () => `/v/activities/${ACTIVITY_STATUS.all}`,
  vActivitiesDetail: (uid: string) => `/v/activities/detail/${uid}`,
  vOrganizations: () => "/v/organizations",
  vOrganizationsDetail: (uid: string) => `/v/organizations/${uid}`,
  vMarkdown: (uid: string) => `/v/documents/${uid}`,
  vSupervisors: () => "/v/supervisors",
  vSupervisorsDetail: (uid: string) => `/v/supervisors/${uid}`,
};

interface UrlNode {
  name: string;
  url: string;
  parent: UrlNode | null;
}

type UrlNodeMap = { [uid: string]: UrlNode[] };

export const breadcrumbs = lazy<UrlNodeMap>(() => {
  const cHome: UrlNode = {
    name: "Home",
    url: URLS.cHome(),
    parent: null,
  };
  const cActivities = {
    name: "Activities",
    url: URLS.cActivities(ACTIVITY_STATUS.all),
    parent: cHome,
  };
  const cActivitiesApproved = {
    name: "Approved Activities",
    url: URLS.cActivities(ACTIVITY_STATUS.approved),
    parent: cHome,
  };
  const cActivitiesPending = {
    name: "Pending Activities",
    url: URLS.cActivities(ACTIVITY_STATUS.pending),
    parent: cHome,
  };
  const cActivitiesRejected = {
    name: "Rejected Activities",
    url: URLS.cActivities(ACTIVITY_STATUS.rejected),
    parent: cHome,
  };

  const vHome: UrlNode = {
    name: "Home",
    url: URLS.vHome(),
    parent: null,
  };
  const vActivities: UrlNode = {
    name: "Activities",
    url: URLS.vActivities(ACTIVITY_STATUS.all),
    parent: vHome,
  };
  const vOrganizations: UrlNode = {
    name: "Organizations",
    url: URLS.vOrganizations(),
    parent: vHome,
  };
  const vSupervisors: UrlNode = {
    name: "Supervisors",
    url: URLS.vSupervisors(),
    parent: vHome,
  };

  return {
    cHome: [cHome],
    cActivities: [cHome, cActivities],
    cActivitiesApproved: [cHome, cActivitiesApproved],
    cActivitiesPending: [cHome, cActivitiesPending],
    cActivitiesRejected: [cHome, cActivitiesRejected],
    vHome: [vHome],
    vActivities: [vHome, vActivities],
    vOrganizations: [vHome, vOrganizations],
    vSupervisors: [vHome, vSupervisors],
  };
});
